module.exports = __webpack_public_path__ + "static/media/darkcat2.f5b8abeb.png";